import { useForm } from 'react-hook-form';

import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';

import { Typography, Box } from '@mui/material';
import MuiDialog from 'components/MuiDialog';

import { SurveyDialogProps, TDNRDefaultValues } from '../../type';
import { updateDNR } from 'apis/survey';

import CommonPatientInfo from '../../components/CommonPatientInfo';
import Signature from './Signature';
import DNRComponents from './DNRComponents';

const DNR = (props: SurveyDialogProps<TDNRDefaultValues>) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    nurseName,
    patientInfo,
    onClose,
  } = props;

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();
  const { handleSubmit, watch, getValues, setValue, register } = useForm({
    defaultValues,
  });

  const onSubmit = (data: TDNRDefaultValues) => {
    const {
      recorde_date,
      recorde_person_name,
      recorde_person_sig,

      register_date,
      register_person_name,
      register_person_sig,
    } = data;

    const request = {
      user_id,
      patient_id: patientInfo.patient_id,
      advance_directive_confirmation: {
        recorde_date,
        recorde_person_name,
        recorde_person_sig,

        register_date,
        register_person_name,
        register_person_sig,
      },
    };

    // console.log(request);

    updateDNR(request)
      .then(({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);

        onUpdateIsSave(true);
        onSuccess('Đã được lưu lại.');
      })
      .catch(e => onFail('Lưu thất bại.', e));
  };

  const formProps = {
    disabled,
    watch,
    getValues,
    setValue,
    onSuccess,
    onRequired,
    register,
  };

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Typography
        sx={{
          margin: '40px auto 40px auto',
          fontWeight: '700',
          fontSize: '16px',
          textAlign: 'center',
        }}
      >
        Chỉ thị không hồi sức DNR
      </Typography>
      <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
      <Box sx={{ marginTop: '48px' }}>
        <DNRComponents />
        <Box sx={{ margin: '20px auto 0px auto', width: '98%' }}>
          <Signature {...formProps} />
        </Box>
      </Box>
    </MuiDialog.SurveyForm>
  );
};

export default DNR;
